<template>
  <div class="navItemDetails">
    <!-- Sub items -->
    <template v-if="selected">
      <div>
        <div
          v-if="currentRecord.institutional_guarantor && currentRecord.institutional_guarantor.id"
          class="navRecordsUser"
          :class="{ active: $route.params.guarantor_id === 'garantie-locative', valid: isValid, invalid: !isValid }"
          @click="$router.push({ path: '/dossiers/' + currentRecord.id + '/modification-de-garant/garantie-locative' })"
        >
          <div class="navRecordsUser__content">
            <span>{{ $t('records.nav.updateInstitutionalGuarantorSubtitle') }}</span>
            <p>{{ currentRecord.institutional_guarantor.title }}</p>
            <div @click="dialogVisible = true">
              <md-icon name="delete" />
            </div>
            <div class="navRecordsUser__bubble">
              {{ $t('records.nav.updateInstitutionalGuarantorBubble') }}
            </div>
          </div>
        </div>
        <nav-records-user
          v-for="(guarant) in guarantors"
          :key="guarant.id"
          :target-id="guarant.id"
          :type="'guarant'"
          :name="guarant.first_name + ' ' + guarant.last_name.toUpperCase()"
          :subtitle="$t('records.nav.garantSubtitle')"
          :bubble="$t('records.nav.garantBubble')"
          :valid="!!guarant.confirmed_at"
          :invalid="guarant.confirmation_sent_at && !guarant.confirmed_at"
          notification="0"
          deleteable
        />
      </div>
      <el-button
        type="info"
        @click="$router.push({ name: 'records-guarant' })"
      >
        <md-icon name="add_circle" />
        <p>{{ $t('records.nav.addGuarants') }}</p>
      </el-button>
    </template>

    <el-dialog
      v-if="currentRecord.institutional_guarantor"
      class="recordCard__dialog"
      :title="$t('records.nav.deleteTitleInstitutionalGuarantor')"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <p>
        {{ $t('records.nav.deleteReally') }}
        &nbsp;
        <span class="primaryColor">{{$t('records.nav.updateInstitutionalGuarantor')}}{{ currentRecord.institutional_guarantor.title }}</span>
        &nbsp;?
      </p>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">{{$t('records.nav.deleteCancel')}}</el-button>
        <el-button
          :loading="dialogLoading"
          @click="handleDelete"
        >{{ $t('records.nav.deleteConfirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import NavRecordsInterface from './NavRecordsInterface'
import NavRecordsUser from './NavRecordsUser'
import { mapState } from 'vuex'

export default {
  name: "NavRecordsGuarantDetails",
  components: {
    NavRecordsUser
  },
  extends: NavRecordsInterface,
  data: () => ({
    dialogVisible: false,
    dialogLoading: false
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord,
      guarantors: state => state.recordsPeople.currentRecordGuarantors
    }),
    isValid() {
      return this.currentRecord.institutional_guarantor && this.currentRecord.institutional_guarantor.id
    }
  },
  methods: {
    async handleDelete() {
      try {
        this.dialogLoading = true
        let recordId = this.$route.params.id

        await this.$store.dispatch('records/updateRecord', {
          record: {
            institutional_guarantor_number: null,
            institutional_guarantor_id: null
          },
          id: recordId
        })

        this.$notify({
          type: 'success',
          title: this.$t('base.success.notificationTitle'),
          message: this.$t('base.success.deleteWithSuccess')
        })

        this.$router.push({ path: '/dossiers/' + recordId + '/ajout-de-garant' })
      } catch (error) {
        console.warn(error)
      }

      this.dialogVisible = false
      this.dialogLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button {
  i,
  p {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    padding-left: 5px;
  }
}
</style>